import React, { useState } from "react";
import { DecompositionTreeGraph } from "@ant-design/graphs";
import PlanInfoModal from "../modal/PlanInfoModal";
import InfoUserModal from "../modal/InfoUserModal";
import IndividualInfoModal from "../modal/IndividualInfoModal";

const IndividualsTree = () => {
  const [infoModal, setInfoModal] = useState(false);
  const proHeight = document.body.clientHeight;

  const data = {
    id: "A0",
    level: "group",
    value: {
      title: "John Doe",
      items: [
        {
          text: "Hayleys",
          value: "CEO",
        },
        {
          text: "Progress",
          value: "40%",
          icon: "https://gw.alipayobjects.com/zos/antfincdn/iFh9X011qd/7797962c-04b6-4d67-9143-e9d05f9778bf.png",
        },
      ],
    },
    children: [
      {
        id: "A1",
        level: "company",
        value: {
          title: "Kevin Hart",
          items: [
            {
              text: "CEO",
              value: "Kingsbury",
            },
            {
              text: "Progress",
              value: "40%",
              icon: "https://gw.alipayobjects.com/zos/antfincdn/iFh9X011qd/7797962c-04b6-4d67-9143-e9d05f9778bf.png",
            },
          ],
        },
        children: [
          {
            id: "A11",
            level: "department",
            value: {
              title: "Ryan Rey",
              items: [
                {
                  text: "MD",
                  value: "finance",
                },
                {
                  text: "Progress",
                  value: "40%",
                  icon: "https://gw.alipayobjects.com/zos/antfincdn/iFh9X011qd/7797962c-04b6-4d67-9143-e9d05f9778bf.png",
                },
              ],
            },
            children: [
              {
                id: "A111",
                level: "division",
                value: {
                  title: "John Stock",
                  items: [
                    {
                      text: "Manager",
                      value: "Division 1",
                    },
                    {
                      text: "Progress",
                      value: "40%",
                      icon: "https://gw.alipayobjects.com/zos/antfincdn/iFh9X011qd/7797962c-04b6-4d67-9143-e9d05f9778bf.png",
                    },
                  ],
                },
              },
              {
                id: "A112",
                level: "division",
                value: {
                  title: "David Rob",
                  items: [
                    {
                      text: "Manager",
                      value: "Division 2",
                    },
                    {
                      text: "Progress",
                      value: "40%",
                      icon: "https://gw.alipayobjects.com/zos/antfincdn/iFh9X011qd/7797962c-04b6-4d67-9143-e9d05f9778bf.png",
                    },
                  ],
                },
              },
            ],
          },
          {
            id: "A12",
            level: "department",
            value: {
              title: "Mark Ruf",
              items: [
                {
                  text: "MD",
                  value: "HR",
                },
                {
                  text: "Progress",
                  value: "40%",
                  icon: "https://gw.alipayobjects.com/zos/antfincdn/iFh9X011qd/7797962c-04b6-4d67-9143-e9d05f9778bf.png",
                },
              ],
            },
          },
          {
            id: "A13",
            level: "company",
            value: {
              title: "Mike Jord",
              items: [
                {
                  text: "COO",
                  value: "Kingsbury",
                },
                {
                  text: "Progress",
                  value: "40%",
                  icon: "https://gw.alipayobjects.com/zos/antfincdn/iFh9X011qd/7797962c-04b6-4d67-9143-e9d05f9778bf.png",
                },
              ],
            },
          },
        ],
      },
      {
        id: "A2",
        level: "company",
        value: {
          title: "Kobe Bry",
          items: [
            {
              text: "CEO",
              value: "Alumex",
            },
            {
              text: "Progress",
              value: "40%",
              icon: "https://gw.alipayobjects.com/zos/antfincdn/iFh9X011qd/7797962c-04b6-4d67-9143-e9d05f9778bf.png",
            },
          ],
        },
        children: [
          {
            id: "A21",
            level: "department",
            value: {
              title: "Aron Bever",
              items: [
                {
                  text: "MD",
                  value: "sales",
                },
                {
                  text: "Progress",
                  value: "40%",
                  icon: "https://gw.alipayobjects.com/zos/antfincdn/iFh9X011qd/7797962c-04b6-4d67-9143-e9d05f9778bf.png",
                },
              ],
            },
            children: [
              {
                id: "A211",
                level: "division",
                value: {
                  title: "Magic John",
                  items: [
                    {
                      text: "Manager",
                      value: "Division  1",
                    },
                    {
                      text: "Progress",
                      value: "40%",
                      icon: "https://gw.alipayobjects.com/zos/antfincdn/iFh9X011qd/7797962c-04b6-4d67-9143-e9d05f9778bf.png",
                    },
                  ],
                },
              },
              {
                id: "A212",
                level: "division",
                value: {
                  title: "Larry Bir",
                  items: [
                    {
                      text: "Manager",
                      value: "Division 2",
                    },
                    {
                      text: "Progress",
                      value: "40%",
                      icon: "https://gw.alipayobjects.com/zos/antfincdn/iFh9X011qd/7797962c-04b6-4d67-9143-e9d05f9778bf.png",
                    },
                  ],
                },
              },
            ],
          },
          {
            id: "A22",
            level: "department",
            value: {
              title: "Scot Pippen",
              items: [
                {
                  text: "MD",
                  value: "marketing",
                },
                {
                  text: "Progress",
                  value: "40%",
                  icon: "https://gw.alipayobjects.com/zos/antfincdn/iFh9X011qd/7797962c-04b6-4d67-9143-e9d05f9778bf.png",
                },
              ],
            },
          },
        ],
      },
    ],
  };

  function getNodeColor(node) {
    let nodeColor = "#91d5ff";
    if (node.level === "group") {
      nodeColor = "rgb(63, 81, 181)";
    } else if (node.level === "company") {
      nodeColor = "rgb(244, 67, 54)";
    } else if (node.level === "department") {
      nodeColor = "rgb(76, 175, 80)";
    } else if (node.level === "division") {
      nodeColor = "rgb(255, 193, 7)";
    }
    return nodeColor;
  }

  const config = {
    data,
    height: proHeight - 172,
    nodeCfg: {
      style: (node) => {
        return {
          stroke: getNodeColor(node),
          cursor: "pointer",
        };
      },
      label: {
        style: {
          cursor: "pointer",
        },
      },
      title: {
        containerStyle: (node) => {
          return {
            fill: getNodeColor(node),
            cursor: "pointer",
          };
        },
      },
    },
    behaviors: ["drag-canvas", "zoom-canvas", "drag-node"],
    edgeCfg: {
      type: "polyline",
      endArrow: true,
    },
    autoFit: false,
  };

  return (
    <>
      <div className="border">
        <DecompositionTreeGraph
          {...config}
          onReady={(graph) => {
            graph.on("node:click", (evt) => {
              setInfoModal(true);
            });
          }}
        />
      </div>
      <IndividualInfoModal
        visible={infoModal}
        handleCancel={() => setInfoModal(false)}
      />
    </>
  );
};

export default IndividualsTree;
